export class CommonDialog {
  constructor(title: string, text: string, valueTitle: string = null) {
    this.Title = title;
    this.Text = text;
    this.ValueTitle = valueTitle;
  }

  Title: string;
  Text: string;
  ValueTitle: string;
}
